import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { string } from 'prop-types';

import {
  fetchFriendsIfNeeded,
  radarIndicatorCountSelector,
} from '@lootboy/lib/slices/radarFriends';
import { fetchInvitationsIfNeeded } from '@lootboy/lib/slices/radarInvitations';

import IconWithNotifications from '~/components/IconWithNotifications';

import { ReactComponent as RadarSvgIcon } from '~/assets/images/iconsLibrary/chat-radar.svg';

function RadarIcon({ className }) {
  const dispatch = useDispatch();
  const indicatorCount = useSelector(radarIndicatorCountSelector);

  // wouldn't it be better if fetching would be done globally in login observer?
  useEffect(() => {
    Promise.all([
      dispatch(fetchFriendsIfNeeded()),
      dispatch(fetchInvitationsIfNeeded()),
    ]).catch(() => undefined);
  }, [dispatch]);

  return (
    <IconWithNotifications
      showBadge={Boolean(indicatorCount)}
      Svg={RadarSvgIcon}
      className={className}
    />
  );
}

RadarIcon.propTypes = {
  className: string,
};

export default RadarIcon;
